import { z } from 'zod'

export const nullableThenRequired = <T extends z.ZodTypeAny>(schema: T) => {
    return schema.nullable().superRefine((val, ctx) => {
        if (val === null) {
            ctx.addIssue({
                code: z.ZodIssueCode.invalid_type,
                expected: schema._def.typeName,
                received: 'null'
            })
        }
    })
}
